































import { Component,  Vue, Prop, Watch } from 'vue-property-decorator';
import { stations, search } from '@/api/api';
import { Notify } from 'vant';
import loading from '@/components/loading/loading.vue';

@Component({
    name: 'query-index',
    components: {
        loading
    }
})

export default class QueryIndex extends Vue {
    private areaCode: any = '';
    private start: any = '';
    private end: any = '';
    private startShow: boolean = false;
    private endShow: boolean = false;
    private startPlace: any = '';
    private endPlace: any = '';
    private startStations: any[] = [];
    private endStations: any[] = [];
    private empty: boolean = false;
    private loading: boolean = true;
    private lines: any[] = [];
    
    // mounted
    private mounted() {
        const begin = this.$route.query.begin;
        const end = this.$route.query.end;
        this.start = begin;
        this.end = end;
        this.startPlace = begin;
        this.endPlace = end;
        const areaCode = localStorage.getItem('areaCode');
        this.areaCode = areaCode;
        this.searchLines({begin, end, areaCode});
    }

    // 获取站点
    private getStations(type: string, val: string): void {
        const areaCode = localStorage.getItem('areaCode');
        const siteName = val;
        stations({areaCode, siteName}).then((res: any) => {
            // console.log(res);
            const data: any[] = res.data;
            if (type === 'start') {
                this.startStations = data;
            } else {
                this.endStations = data;
            }
        });
    }
    // 输入框获得焦点时间
    private focus(type: string): void {
        if (type === 'start') {
            this.startShow = true;
            this.endShow = false;
        } else {
            this.startShow = false;
            this.endShow = true;
        }
    }
    // 输入框失去焦点事件
    private blur(): void {
        setTimeout(() => {
            this.startShow = false;
            this.endShow = false;
            this.start = this.startPlace;
            this.end = this.endPlace;
        }, 100);
    }
    // 输入框输入内容
    @Watch('start', { deep: true })
    private onStartChanged(val: string, oldVal: string) {
        if (val) {
            this.getStations('start', val);
        } else {
            this.startStations = [];
        }
    }
    @Watch('end', { deep: true })
    private onEndChanged(val: string, oldVal: string) {
        if (val) {
            this.getStations('end', val);
        } else {
            this.endStations = [];
        }
    }
    // 选择站点
    private chooseStation(type: string, name: string): void {
        if (type === 'start') {
            this.startPlace = name;
            this.start = name;
        } else {
            this.endPlace = name;
            this.end = name;
            this.startShow = false;
            this.endShow = false;
        }
    }
    // 搜索线路
    private searchLines(params: any): void {
        search(params).then((res: any) => {
            // console.log(res);
            const data: any[] = res.data;
            if (data.length === 0) {
                this.empty = true;
                
            } else {
                this.empty = false;
            }
            this.lines = data;
            this.loading = false;
        });
    }
    // 查询
    private query(): void {
        const begin: string = this.startPlace;
        const end: string = this.endPlace;
        if (!begin) {
            Notify('请输入出发地');
            return;
        }
        if (!end) {
            Notify('请输入目的地');
            return;
        }
        const areaCode = localStorage.getItem('areaCode');
        this.searchLines({begin, end, areaCode});
    }
    // 详情
    private goResult(lineId: string, direction: string, lineCode: string): void {
        this.$router.push({
            path: '/queryResult',
            query: {
                lineId,
                direction,
                lineCode
            }
        });
    }
}
